import { resolveAppData } from '@/logic/app-data';
import { isNativeApiAllowedRoute } from '@/logic/app-data/app-data-route';
import { getPageConfig } from '@/lib/aggregation';
import { getIsSiteWideJackpotEnabled } from '@/logic/page-config/static-page/static-page-utils';
import { getCategoryChromeSource } from '@/logic/layout-adapter/get-category-chrome-source';

export type FeatureFlagsResult = {
    featureFlags: Record<string, true>;
    isSiteWideJackpotEnabled: boolean;
};

/** Builds the enabled-flag lookup shared by the GFE, native and aggregation sources. */
const toFlagMap = (featureNames: string[]): Record<string, true> =>
    featureNames.reduce(
        (acc, featureName) => {
            acc[featureName] = true;
            return acc;
        },
        {} as Record<string, true>
    );

export const getFeatureFlags = async ({ currentRoute }: { currentRoute: string }): Promise<FeatureFlagsResult> => {
    const chrome = await getCategoryChromeSource(currentRoute);
    if (chrome.source === 'gfe') {
        return {
            featureFlags: toFlagMap(chrome.response.features ?? []),
            isSiteWideJackpotEnabled: Boolean(chrome.response.siteWideJackpot?.enabled)
        };
    }

    if (!isNativeApiAllowedRoute(currentRoute)) {
        const response = await getPageConfig(currentRoute);
        const featureNames =
            response?.pageConfig?.product?.data?.features?.map(({ feature_name }) => feature_name) ?? [];

        return {
            featureFlags: toFlagMap(featureNames),
            isSiteWideJackpotEnabled: getIsSiteWideJackpotEnabled(response?.pageConfig?.product)
        };
    }

    const shell = (await resolveAppData(currentRoute))?.shell;

    return {
        featureFlags: toFlagMap(shell?.productFeatures ?? []),
        isSiteWideJackpotEnabled: shell?.siteWideJackpot.enabled === true
    };
};
